// libs
import { useSelector } from 'react-redux'
// store
import { objectEntitiesSelector } from 'store/reducers/objectEntities'
// utils
import orderBy from 'lodash/orderBy'
import { getPropertyKeyByType } from 'utils/reviews'

// review questions and review picklists configured on the object entity of the reviewed item
export const useReviewQuestions = (entityType: string) => {
  const objectEntities = useSelector(objectEntitiesSelector)

  const objectEntity = objectEntities.find((item) => item.name === getPropertyKeyByType(entityType))
  const reviewFieldIds = objectEntity?.reviewFieldIds || []

  return {
    questions: orderBy(objectEntity?.reviewQuestions, 'position'),
    picklists: orderBy(
      (objectEntity?.fields || []).filter((field) => reviewFieldIds.includes(field.id)),
      'position'
    )
  }
}
